import {initContactsForm} from "../contacts-form";
import tippy from "tippy.js";

export function initRateUs() {
    const block = $('#rate_us');
    const form = $('#rate_us_form');
    const openBlockBtn = block.find('[data-open-btn]');
    const closeBlockBtn = block.find('[data-close-btn]');
    const clearForm = initContactsForm(form);
    const tippyInstance = tippy(openBlockBtn[0], {
        arrow: true,
        content: openBlockBtn.attr('data-rate-tooltip'),
        theme: 'shadow',
        hideOnClick: true
    })

    closeBlockBtn.on('click', function(e) {
        e.preventDefault();
        form.addClass('hide');
        openBlockBtn.removeClass('hide');
        clearForm();
    });

    openBlockBtn.on('click', function(e) {
        e.preventDefault();
        tippyInstance.hide();
        form.removeClass('hide');
        openBlockBtn.addClass('hide');
    });
}
